<template>
  <BoxGroup :col="false" :small="true">
    <Box v-for="pp in prevPages" :key="pp" :action="() => onPage(pp)">{{pp}}</Box>
    <Box><Txt :bold="true">{{page}}</Txt></Box>
    <Box v-for="np in nextPages" :key="np" :action="() => onPage(np)">{{np}}</Box>
  </BoxGroup>
</template>

<script>
import BoxGroup from "@/components/ui/layout/BoxGroup";
import Box from "@/components/ui/layout/Box";
import Txt from "@/components/ui/utils/Txt";
export default {
  name: "Pagination",
  components: {Txt, Box, BoxGroup},
  props: {
    total: Number,
    page : {type: Number, default: 1},
    limit : {type: Number, default: 25},
    before : {type: Number, default: 4},
    after : {type: Number, default: 4},
  },

  computed : {
    totalPages() {
      return Math.ceil(this.total / this.limit)
    },
    prevPages() {
      let pages = [], max = this.before;
      for (let i = this.page-1; i >= 1 && max > 0; i--, max--) {
        pages.push(i)
      }
      pages = pages.reverse()
      return ['<<','<',...pages];
    },
    nextPages() {
      let pages = [], max = this.after
      for (let i = this.page+1; i <= this.totalPages && max > 0; i++, max--) {
        pages.push(i)
      }
      return [...pages,'>','>>'];
    }
  },

  methods : {
    onPage(page) {
      if (page === '<') page = this.page > 1 ? this.page-1 : this.page
      else if (page === '<<') page = 1
      else if (page === '>') page = this.page < this.totalPages ? this.page+1 : this.page
      else if (page === '>>') page = this.totalPages

      this.$emit('change', page);
      return true
    }
  }
}
</script>
